// components/CategoryCarousel.jsx
import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

// High quality travel images
const categories = [
  { 
    label: "Trekking Tours", 
    path: "/trekkingtours", 
    img: "https://images.unsplash.com/photo-1551632811-561732d1e306?auto=format&fit=crop&w=300&q=80" 
  },
  { 
    label: "Motorcycle Tours", 
    path: "/motorcylestours", 
    img: "https://www.swantour.com/blogs/wp-content/uploads/2019/05/Leh-Ladakh-Bike-Trip.jpg" 
  },
  { 
    label: "All Tour Packages", 
    path: "/tourpackages", 
    img: "https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=300&q=80" 
  },
  { 
    label: "Go Himachal Services", 
    path: "/contactuss", 
    img: "https://i.pinimg.com/736x/d5/f5/12/d5f512cd828dcb815f948e2c3037ea89.jpg" 
  }
];

const CategoryCarousel = ({ onNavigate }) => {
  return (
    <Box 
      sx={{
        bgcolor: "#ffffff",
        py: 1.5,
        px: 1,
        display: "flex",
        justifyContent: "space-between", // Distributes evenly to fit width
        gap: 0.5,
        boxShadow: "0 4px 6px -4px rgba(0,0,0,0.1)"
      }}
    >
      {categories.map((item, index) => (
        <Box
          key={item.path}
          onClick={() => onNavigate(item.path)}
          sx={{
            flex: 1, // Forces all 4 items to fit in one width equally
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            cursor: "pointer",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            "&:hover": {
              transform: "translateY(-5px)"
            }
          }}
        >
          {/* Cool Image Container with rounded corners */}
          <Box
            sx={{
              width: "100%",
              aspectRatio: "1/1", // Keeps it square
              borderRadius: "16px",
              overflow: "hidden",
              mb: 0.8,
              border: "2px solid transparent",
              transition: "border-color 0.3s",
              "&:hover": {
                borderColor: "#2e7d32"
              }
            }}
          >
            <img 
              src={item.img} 
              alt={item.label} 
              style={{ 
                width: "100%", 
                height: "100%", 
                objectFit: "cover",
                transition: "transform 0.5s",
              }} 
              loading="lazy"
            />
          </Box>
          
          {/* Beautiful Typography */}
          <Typography 
            variant="caption" 
            fontWeight={800} 
            align="center" 
            sx={{ 
              color: "#37474f", 
              lineHeight: 1.1,
              fontSize: "0.75rem",
              textTransform: "uppercase",
              letterSpacing: 0.5
            }}
          >
            {item.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default CategoryCarousel;